module.exports = __webpack_public_path__ + "static/media/0021_LES_ENSEIGNES_LES_PAINS_LETTRE_A_LETTRE.c78a0373.png";